/* eslint-disable max-len */

import React from 'react'
import CartItemShimmer from '../../../Components/CartItemCard/CartItemShimmer'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'
function OfferDetailsShimmer() {
    return (
        <div className="md:px-[46px] px-4 pt-2 mb-7">
            <p className="text-[#090406] font-normal text-xs2 w-1/4"><ShimmerText line={1} gap={10} variant="primary" /></p>
            <div className="flex lg:flex-nowrap flex-wrap">
                <div className="w-full">
                    <div className="flex items-center mt-2.5 w-full">
                        <ShimmerCircularImage size={80} />
                        <div className="sm:pl-[26px] pl-0 w-full">
                            <div className="flex justify-between sm:flex-row flex-col mt-5">
                                <ShimmerSectionHeader subTitle={false}/>  
                                <ul className="flex items-center">
                                    <li>
                                        <ShimmerButton size="sm"/>
                                    </li>
                                    <li className="ml-2">
                                        <ShimmerButton size="sm" />
                                    </li>
                                </ul>
                            </div>
                            <p className="text-[#44445E] font-normal sm:text-xs9 text-base pt-3"><ShimmerBadge width="400"/></p>
                            <ShimmerText line={4} gap={10} variant="primary" />
                        </div>
                    </div>
                    <div className="flex items-start pt-4 sm:pl-[102px] pl-0 note1">
                        <ShimmerText line={2} gap={10} variant="primary" />
                    </div>
                </div>
            </div>
            <div className="w-full flex mt-10">
                <ul className="nav nav-pills flex border-2 border-[#E9EDF4] rounded-lg h-[57px] w-full" style={{overflowY: 'hidden',flexDirection: 'column', display:'-webkit-inline-box'}} id="pills-tabVertical" role="tablist">
                    {[...Array(4)].map((item)=>(
                        <li key={item} className="nav-item flex-grow flex justify-center items-center text-center sm:min-w-[25%] min-w-[60%] border-r-2 border-[#E9EDF4]" role="presentation">
                            <ShimmerButton size="md" className='mt-5'/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="tab-content w-full" id="pills-tabContentVertical">
                <div className="tab-pane fade show active w-full" id="home3" role="tabpanel" aria-labelledby="pill3">
                    <div className="rounded-lg border-2 border-[#E9EDF4] mt-[30px]">
                        <div className="px-3.5 py-5 sm:min-w-[80%] min-w-[100%]">
                            <div className="flex sm:flex-nowrap flex-wrap -mx-2">
                                <div className="px-2 sm:min-w-[25%] min-w-[50%]">
                                    <p className="font-semibold text-sm text-[#090406]"><ShimmerBadge width={100}/></p>
                                    <p className="text-xs9 font-semibold text-[#555259] pt-0.5"><ShimmerBadge width={100}/></p>
                                </div>
                                <div className="px-2 sm:min-w-[25%] min-w-[50%]">
                                    <p className="font-semibold text-sm text-[#090406]"><ShimmerBadge width={100}/></p>
                                    <p className="text-xs9 font-semibold text-[#555259] pt-0.5"><ShimmerBadge width={100}/></p>
                                </div>
                                <div className="px-2 sm:min-w-[25%] min-w-[50%] sm:mt-0 mt-3">
                                    <p className="font-semibold text-sm text-[#090406]"><ShimmerBadge width={100}/></p>
                                    <p className="text-xs9 font-semibold text-[#555259] pt-0.5"><ShimmerBadge width={50}/></p>
                                </div>
                                <div className="px-2 sm:min-w-[25%] min-w-[50%] sm:mt-0 mt-3">
                                    <p className="font-semibold text-sm text-[#090406]"><ShimmerBadge width={100}/></p>
                                    <p className="text-xs9 font-semibold text-[#555259] pt-0.5"><ShimmerBadge width={50}/></p>
                                </div>
                            </div>
                            <p className="font-semibold text-sm text-[#090406] pt-4"><ShimmerBadge width={100}/></p>
                            <p  className="text-[#555259] font-semibold sm:text-lg text-sm"><ShimmerBadge width={300}/> </p>
                        </div>
                    </div>
                </div>
               
                <div className="flex justify-center mt-10">
                    <button type="button" className="w-[210px] h-10 rounded-lg text-sm text-[#FFFFFF] font-semibold view-products">
                        <ShimmerButton size={"md"}/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default OfferDetailsShimmer